export const upsetData = [
  {
    sets: [0, 0, 0, 0, 1],
    size: 12948,
    skills: [
      'SDET',
      'Pascal',
      'CMake',
      'AFSIM',
      'Maui',
      'OpenAPI',
      'Servlet',
      'Mocha',
      'RPG',
      'AMQP',
    ],
  },
  {
    sets: [0, 0, 0, 1, 0],
    size: 4840,
    skills: [
      'C4I',
      'Strong Eyesight',
      'Breaking the ice (conversation)',
      'Ransomware',
      'NISPOM',
      'RHCE',
      'RHIT',
      'LPIC',
      'Plotter',
      'ASL',
    ],
  },
  {
    sets: [0, 0, 1, 0, 0],
    size: 5577,
    skills: [
      'Waxing',
      'Buffing',
      'Transaxle Certification',
      'Clean Bathroom',
      'Replace Windshield',
    ],
  },
  {
    sets: [0, 1, 0, 0, 0],
    size: 2395,
    skills: [
      'NINA',
      'IPsoft',
      'Tracking Experience',
      'Avaya Enterprise',
      'BERT',
      'Inference',
      'LSTMS',
      'DeepSpeed',
      'Horovod',
      'AI/ML',
    ],
  },
  {
    sets: [1, 0, 0, 0, 0],
    size: 609,
    skills: ['HPT', 'GSPAS', 'Simulink', 'Successful Collaborator'],
  },
  {
    sets: [0, 0, 0, 1, 1],
    size: 2454,
    skills: [
      'WPF',
      'MVVM',
      'WinDBG',
      'RS232',
      'DDK',
      'DMM',
      'Flutter',
      'Spring Boot',
      'Delphi',
      'Cypress',
    ],
  },
  {
    sets: [0, 0, 1, 0, 1],
    size: 1227,
    skills: ['CSI', 'UART', 'Debugging', 'OJT', 'V2X'],
  },
  {
    sets: [0, 0, 1, 1, 0],
    size: 567,
    skills: [
      'Drainage Layouts',
      'National Guard',
      'Microcomputing Maintenance',
      'IvyLearn Management System',
      'Preconstruction',
    ],
  },
  {
    sets: [0, 1, 0, 0, 1],
    size: 1171,
    skills: [
      'Panda',
      'MLflow',
      'Data Annotation',
      'ONNX',
      'CUDA',
      'NumPy',
      'Bedrock',
      'CNNS',
      'Tensorflow',
      'RNNS',
    ],
  },
  {
    sets: [0, 1, 0, 1, 0],
    size: 180,
    skills: [
      'CIA',
      '8x8',
      'Amelia',
      'RHCSA',
      'Understanding',
      'CRISC',
      'Causative',
      'IRB',
      'Workcell',
      'PCAOB',
    ],
  },
  {
    sets: [0, 1, 1, 0, 0],
    size: 125,
    skills: ['ACV', 'Charisma', 'AIA', 'RECON', 'MLP', 'Saber'],
  },
  {
    sets: [1, 0, 0, 0, 1],
    size: 114,
    skills: [
      'IEEE',
      'DaVinci',
      'Capacitor',
      'Breadboard',
      'DAQ',
      'Q3D',
      'ISO9000',
      'TargetLink',
      'ISO15118',
      'Programming',
    ],
  },
  {
    sets: [1, 0, 0, 1, 0],
    size: 33,
    skills: [
      'NMC',
      'Symposia',
      'XRD',
      'LGES',
      'ISM',
      'EPP',
      'Centrifugal',
      'DSM',
      'Writeup',
    ],
  },
  {
    sets: [1, 0, 1, 0, 0],
    size: 127,
    skills: [
      'EVB',
      'Fiberglass',
      'Electrochemistry',
      'Hazmat',
      'Remanufacturing',
    ],
  },
  {
    sets: [1, 1, 0, 0, 0],
    size: 14,
    skills: ['KiCad', 'MS365'],
  },
  {
    sets: [0, 0, 1, 1, 1],
    size: 1230,
    skills: [
      'Navigation',
      'NPS',
      'TFS',
      'ReactJS',
      'Photography',
      'CMS',
      'ABAP',
      'BPM',
    ],
  },
  {
    sets: [0, 1, 0, 1, 1],
    size: 861,
    skills: [
      'MVC',
      'Science',
      'JSON',
      'MySQL',
      'LLM',
      'Terraform',
      'Lambda',
      'Kafka',
      'PostgreSQL',
      'DevSecOps',
    ],
  },
  {
    sets: [0, 1, 1, 0, 1],
    size: 285,
    skills: [
      'Factuality',
      'Kotlin',
      'MPI',
      'Ensemble Techniques',
      'Perforce',
      'VIM',
      'Debian',
      'PCIE',
      'APIM',
    ],
  },
  {
    sets: [0, 1, 1, 1, 0],
    size: 62,
    skills: ['Naive Bayes', 'Physiologic Assays', 'WPM', 'Artwork'],
  },
  {
    sets: [1, 0, 0, 1, 1],
    size: 74,
    skills: ['VoIP', 'Decomposition', 'Mathworks Code Generation'],
  },
  {
    sets: [1, 0, 1, 0, 1],
    size: 137,
    skills: ['ASPICE', 'PFMEA', 'OBD', 'GMS', 'BSEE'],
  },
  {
    sets: [1, 0, 1, 1, 0],
    size: 61,
    skills: ['ASPICE', 'systems integration', 'telemetry'],
  },
  {
    sets: [1, 1, 0, 0, 1],
    size: 25,
    skills: ['Bootload', 'Interrogate', 'software design'],
  },
  {
    sets: [1, 1, 0, 1, 0],
    size: 10,
    skills: ['Dissertation', 'Drawback', 'LI-DC1', 'Osteopath'],
  },
  {
    sets: [1, 1, 1, 0, 0],
    size: 7,
    skills: ['Abaqus', 'Hypermesh', 'COMSOL'],
  },
  {
    sets: [0, 1, 1, 1, 1],
    size: 1593,
    skills: [
      'Automobile Manufacturing',
      'Interior Repair',
      'Unloading',
      'Oscilloscopes',
      'Inspector',
      'ECU',
      'CPR',
      'Minitab',
      'Autodesk',
      'Photoshop',
    ],
  },
  {
    sets: [1, 0, 1, 1, 1],
    size: 451,
    skills: ['software engineering', 'battery systems', 'automation'],
  },
  {
    sets: [1, 1, 0, 1, 1],
    size: 63,
    skills: ['Docker', 'Unix', 'Waterfall', 'TDD', 'CCNA'],
  },
  {
    sets: [1, 1, 1, 0, 1],
    size: 56,
    skills: [
      'Lex',
      'Microcontroller',
      'Copywrite',
      'Linux',
      'Finite',
      'Taxi',
      'Microprocessor',
      'ECU',
      'DFM',
      'DFA',
    ],
  },
  { sets: [1, 1, 1, 1, 0], size: 9, skills: ['PoV'] },
  {
    sets: [1, 1, 1, 1, 1],
    size: 3044,
    skills: [
      'Development',
      'Management',
      'Programming',
      'Design',
      'Technical knowledge',
      'Excel',
      'Medical',
      'Analytical',
      'Python',
      'Database',
    ],
  },
]

export const upsetSetNames = [
  'Electric Battery Production',
  'Artificial Intelligence',
  'Automotive Manufacturing',
  'Information Technology',
  'Software Development',
]
